import { apiClient } from '@shared/utils/api-client';

export interface OrderCategoryStatsRow {
    categoryId: number;
    categoryName: string;
    ordersCount: number;
    itemsSold: number;
    revenue: number;
    /** Для порядка как GET /categories/popular-by-sales — на UI не показываем. */
    categoryCreatedAt?: string | null;
}

export const orderCategoryStatsApi = {
    list: (params?: { dateFrom?: string; dateTo?: string }) => {
        const search = new URLSearchParams();
        if (params?.dateFrom) search.set('dateFrom', params.dateFrom);
        if (params?.dateTo) search.set('dateTo', params.dateTo);
        const q = search.toString();
        return apiClient.get<OrderCategoryStatsRow[]>(`/order-category-stats${q ? `?${q}` : ''}`);
    },
};
